<div class="app-receipt">
  <h1 class="account-page-title">Receipts</h1>

  <div class="table-wrapper">
    <div class="table">
      <div style="overflow: auto;">
        <table mat-table [dataSource]="dataSource" matSort style="background-color: transparent">

          <!-- Network Column -->
          <ng-container matColumnDef="network">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Network</th>
            <td mat-cell *matCellDef="let element">
              <div class="network-cell">
                <img [src]="element.networkLogo" [alt]="element.networkName" class="network-logo" onerror="this.style.display='none'" />
                <span class="network-name">{{ element.networkName }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Location Column -->
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
            <td mat-cell *matCellDef="let element">
              <div class="location-cell">
                <span class="location-name">{{ element.locationName }}</span>
                <span class="location-address">{{ element.address }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Energy Column -->
          <ng-container matColumnDef="energy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Energy</th>
            <td mat-cell *matCellDef="let element">
              <span class="energy-value">{{ element.energyKwh | number:'1.1-1' }} kWh</span>
            </td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
            <td mat-cell *matCellDef="let element">
              <span class="duration-value">{{ formatDuration(element.durationMinutes) }}</span>
            </td>
          </ng-container>

          <!-- Total Column -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
            <td mat-cell *matCellDef="let element">
              <span class="total-value">{{ element.totalAmount | currency }}</span>
            </td>
          </ng-container>

          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let element">
              <span class="date-value">{{ element.date | date:'MMM d, y' }}</span>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="status-badge" [ngClass]="getStatusClass(element.status)">
                {{ element.status }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)" class="clickable-row"></tr>
        </table>
      </div>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page"
        style="background-color: transparent"
      >
      </mat-paginator>
    </div>
  </div>
</div>
